import Styleguide from "@store/Framework/Types/Styleguide";

const signIn: Styleguide["signIn"] = {};

export default signIn;
